import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgressIndicatorService {
  public text: string;

  constructor() { }

  public progress: boolean;
}
